export class ApiInvoiceObject {
    invoiceId: string | undefined;
    invoiceNumber: string | undefined;
    dueDate: Date | undefined;
    orderNumber: string | undefined;
    balance: number | undefined;
    orderId: string | undefined;
    poNumber: string | undefined;
    invoiceDate: Date | undefined;
    totalAmount: number | undefined;
    taxAmount: number | undefined;
    invoiceRows: ApiInvoiceRowObject[] | undefined;
    shiptoname: string | undefined;
    shiptoaddress: string | undefined;
    shiptocity: string | undefined;
    shiptostate: string | undefined;
    freightAmount: number | undefined;
    productAmount: number | undefined;
    materialSurchargeAmount: number | undefined;
    miscChargesAmount: number | undefined;
    customerName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;

    constructor(
        invoiceId: string | undefined,
        invoiceNumber: string | undefined,
        dueDate: Date | undefined,
        orderNumber: string | undefined,
        balance: number | undefined,
        orderId: string | undefined,
        poNumber: string | undefined,
        invoiceDate: Date | undefined,
        totalAmount: number | undefined,
        taxAmount: number | undefined,
        shiptoname: string | undefined,
        shiptoaddress: string | undefined,
        shiptocity: string | undefined,
        shiptostate: string | undefined,
        freightAmount: number | undefined,
        productAmount: number | undefined,
        materialSurchargeAmount: number | undefined,
        miscChargesAmount: number | undefined,
        invoiceRows: ApiInvoiceRowObject[] | undefined,
        customerName: string | undefined,
        address: string | undefined,
        city: string | undefined,
        state: string | undefined,
        country: string | undefined
    ) {
        this.invoiceId = invoiceId;
        this.invoiceNumber = invoiceNumber;
        this.dueDate = dueDate;
        this.orderNumber = orderNumber;
        this.balance = balance;
        this.orderId = orderId;
        this.poNumber = poNumber;
        this.invoiceDate = invoiceDate;
        this.totalAmount = totalAmount;
        this.taxAmount = taxAmount;
        this.shiptoname = shiptoname;
        this.shiptoaddress = shiptoaddress;
        this.shiptocity = shiptocity;
        this.shiptostate = shiptostate;
        this.invoiceRows = invoiceRows;
        this.freightAmount = freightAmount;
        this.productAmount = productAmount;
        this.materialSurchargeAmount = materialSurchargeAmount;
        this.miscChargesAmount = miscChargesAmount;
        this.customerName = customerName;
        this.address = address;
        this.city = city;
        this.state = state;
        this.country = country;
    }
}

export class ApiInvoiceRowObject {
    lineNumber: number | undefined;
    itemNumber: string | undefined;
    orderedQty: number | undefined;
    deliveredQty: number | undefined;
    backorderQty: number | undefined;
    unitPrice: number | undefined;
    discount: number | undefined;
    amount: number | undefined;
    description: string | undefined;
    constructor(
        lineNumber: number | undefined,
        itemNumber: string | undefined,
        orderedQty: number | undefined,
        deliveredQty: number | undefined,
        backorderQty: number | undefined,
        unitPrice: number | undefined,
        discount: number | undefined,
        amount: number | undefined,
        description: string | undefined
    ) {
        this.lineNumber = lineNumber;
        this.itemNumber = itemNumber;
        this.orderedQty = orderedQty;
        this.deliveredQty = deliveredQty;
        this.backorderQty = backorderQty;
        this.unitPrice = unitPrice;
        this.discount = discount;
        this.amount = amount;
        this.description = description;
    }
}

export class ApiInvoicesState {
    invoices: ApiInvoiceObject[];
    loading: boolean;
}



// WEBPACK FOOTER //
// ./src/data/invoices/invoicesModels.ts